module.exports = __webpack_public_path__ + "img/img_32@2x.450a6779.png";